{
  "splash": {
    "title": "Developed with the support of the Government of Canada"
  },
  "all-listings": {
    "disconnected": {
      "text": "Create an account or log in to see the available resources on ACCÈS REFRAIN."
    },
    "needLogin": {
      "secondLine": "Create an account or log in to see the available resources on ACCÈS REFRAIN."
    },
    "empty": {
      "offer": {
        "firstLine": "Start your adventure here!",
        "primaryButtonText": "Publish an offer!",
        "secondLine": "Contribute to the catalog by offering objects to lend."
      }
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Create an account or log in",
    "unauthenticatedTitle_2": "to see the available resources in ACCÈS REFRAIN."
  },
  "common": {
    "appName": "ACCÈS REFRAIN",
    "appDownloadPrompt": {
      "guest": "Like what you see? Get ACCÈS REFRAIN on your phone and receive new availability near you",
      "qrCodeAccessibilityLabel": "QR code to download the ACCÈS REFRAIN app"
    }
  },
  "contact-information": {
    "prompt": "Add the festival's postal code to see which objects are available nearby.",
    "title": "Your address"
  },
  "contact-us": {
    "firstParagraph": "ACCÈS REFRAIN member service is accessible by email and messaging. We will respond to you as quickly as possible.",
    "faqLink": "https://lerefrain.com/en/foire-aux-questions-acces-refrain-2",
    "chatPrompt": {
      "bugReport": "Hi! 😊\n\nThank you for explaining what's wrong.",
      "suggestion": "Hi! 😊\n\nWe are always open to feedbacks. Thank you for helping us improve our service.\n\nThank you!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "An invitation code is required to use ACCÈS REFRAIN. To get one, go to <a>the Refrain member area</a>.",
    "activationCodeFieldHelpLink": "https://lerefrain.com/en/connexion"
  },
  "guidelines": {
    "fifthParagraph": "Do not use ACCÈS REFRAIN to sell objects."
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Join ACCÈS REFRAIN",
        "title": "Explorer"
      }
    }
  },
  "introModal": {
    "title": "Dear {{name}},",
    "first": "Welcome to the sharing application and discover the <strong>vast catalog of available material resources!</strong>",
    "second": "<strong>Sharing is a sign of trust</strong>: the more you lend, the more others will want to lend to you!",
    "third": "<strong>Know that less than 0.1% of all shares</strong> result in a break. And it's not in bad faith. It's just normal when objects are used a little more."
  },
  "my-information": {
    "firstNameFieldLabel": "Festival name",
    "credentialInformationTitle": "Account & security",
    "personalInformationTitle": "Profile information"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Festival name",
    "firstNameFieldPlaceholder": "ex. Bon-Vent de Ste-Pépitte Festival",
    "title": "Profile information"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Your ACCÈS REFRAIN subscription is a courtesy of the Refrain."
      },
      "title": {
        "enterprise": "ACCÈS REFRAIN subscription"
      }
    },
    "refrainPlan": {
      "firstParagraph": "",
      "title": "ACCÈS REFRAIN subscription"
    },
    "noEnd": "This subscription is valid as long as you are a member of Refrain."
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Sound console",
      "descriptionFieldPlaceholder": {
        "offer": "Brand, dimensions, color, weight, condition, year of acquisition, borrowing conditions, object specifics ...",
        "request": "Brand, dimensions, color, weight, condition, year of acquisition, borrowing conditions, object specifics ..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Welcome to the club",
        "body": "Discover ACCÈS REFRAIN!"
      }
    },
    "welcome": "Welcome to ACCÈS REFRAIN!",
    "welcomeMessage": "Thank you for trusting us.",
    "rate": {
      "borrower": {
        "message": "Your opinion is important to us and to other members of ACCÈS REFRAIN."
      },
      "lender": {
        "message": "Your opinion is important to us and to other members of ACCÈS REFRAIN."
      }
    }
  },
  "one-channel": {
    "levelModal": {
      "superSharer": {
        "message": "You have increased your impact by making 5 shares! You now access the ultimate level: <strong>Super Sharer</strong> and a role model for other members of ACCÈS REFRAIN.\n\nBravo! With each share, you grow your impact for a greener future."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "The need has been fulfilled on ACCÈS REFRAIN"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Festival name",
    "firstNameFieldPlaceholder": "ex. Bon-Vent de Ste-Pépitte Festival",
    "pictureFieldSubtitle": "This image will be displayed in your ads and your profile.",
    "pictureFieldTitle": "Add an image of the festival logo",
    "title": "Profile information"
  },
  "privacy": {
    "link1": "https://lerefrain.com/en/acces-refrain-terms-of-use",
    "link2": "https://lerefrain.com/en/acces-refrain-politique-de-confidentialite",
    "line3": "of ACCÈS REFRAIN."
  },
  "quick-new-thanks": {
    "bodyText": "You have just helped enrich the <strong>ACCÈS REFRAIN</strong> catalog! \n\nYou can modify your offers at any time in your sharing center."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contact ACCÈS REFRAIN"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "By offering your objects, you encourage even the most timid festivals to ask."
      }
    }
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Accès Refrain is the app for <strong>sharing equipment</strong> between festivals.",
      "footerText": "Don't <strong>limit</strong> yourself to what your organization owns."
    },
    "accessMore": {
      "headerText": "With Accès Refrain, you have access to an <strong>abundance of equipment</strong>.",
      "footerText": "Equipment, stages, and more: here, you'll find <strong>absolutely everything.</strong>"
    },
    "offerMore": {
      "headerText": "With Accès Refrain, <strong>sharing</strong> means <strong>helping</strong> other festivals while <strong>making the most of your resources</strong>.",
      "footerText": "Let other festivals <strong>benefit</strong> from your <strong>underused equipment.</strong>"
    }
  }
}
